<div class="publish-date-panel">
  <div class="pdp-filters">
    <!-- Previous month -->
    <button type="button" class="pdp-cal-nav" (click)="prevMonth()" [disabled]="!canPrevMonth()"
      [attr.aria-label]="'HOME.calendar_prev_month' | translate" [title]="'HOME.calendar_prev_month' | translate">&lsaquo;</button>

    <!-- Day: opens the month calendar as a popover; a marked day scrolls the list to that date -->
    <div class="pdp-day-wrap">
      <button type="button" class="pdp-day-btn" [class.active]="showCalendar || day !== ''" (click)="toggleCalendar($event)"
        [attr.aria-expanded]="showCalendar" [attr.aria-label]="'HOME.calendar_date' | translate"
        [title]="'HOME.calendar_date' | translate">
        <svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">
          <path fill="currentColor" d="M19 4h-1V2h-2v2H8V2H6v2H5C3.9 4 3 4.9 3 6v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zM7 11h5v5H7z"/>
        </svg>
        <span class="pdp-day-label" *ngIf="day !== ''">{{ day }}</span>
        <i class="pdp-caret" aria-hidden="true"></i>
      </button>

      <aside class="pdp-calendar" *ngIf="showCalendar">
        <div class="pdp-cal-title">
          <button type="button" class="pdp-cal-nav small" (click)="prevMonth()" [disabled]="!canPrevMonth()"
            [attr.aria-label]="'HOME.calendar_prev_month' | translate" [title]="'HOME.calendar_prev_month' | translate">&lsaquo;</button>
          <span>{{ monthLabel() }} {{ year }}</span>
          <button type="button" class="pdp-cal-nav small" (click)="nextMonth()" [disabled]="!canNextMonth()"
            [attr.aria-label]="'HOME.calendar_next_month' | translate" [title]="'HOME.calendar_next_month' | translate">&rsaquo;</button>
        </div>
        <div class="pdp-cal-grid" [class.loading]="loading">
          <span class="pdp-cal-weekday" *ngFor="let w of weekdays">{{ w }}</span>
          <ng-container *ngFor="let cell of cells">
            <span class="pdp-cal-cell empty" *ngIf="!cell.day"></span>
            <button type="button" class="pdp-cal-cell" *ngIf="cell.day"
              [class.has-items]="cell.count > 0" [class.today]="cell.isToday" [class.selected]="isSelectedDay(cell.date)"
              [disabled]="cell.count === 0" (click)="selectDay(cell)"
              [attr.title]="cell.count > 0 ? cell.count + ' ' + ('HOME.calendar_items' | translate) : null">
              <span class="pdp-cal-num">{{ cell.day }}</span>
              <span class="pdp-cal-count" *ngIf="cell.count > 0">{{ cell.count }}</span>
            </button>
          </ng-container>
        </div>
        <div class="pdp-cal-foot">
          <button type="button" class="pdp-cal-today" (click)="goToday()">{{ 'HOME.calendar_today' | translate }}</button>
        </div>
      </aside>
    </div>

    <!-- Month / year / kind: custom dropdowns, not native selects, so the open list can carry
         the header menu's look (a native option list is drawn by the OS and cannot be styled). -->
    <div class="pdp-drop pdp-cal-month" [class.open]="openDrop === 'month'">
      <button type="button" class="pdp-drop-btn" (click)="toggleDrop('month', $event)"
        [attr.aria-expanded]="openDrop === 'month'" [attr.aria-label]="monthLabel()">
        <span class="pdp-drop-value">{{ monthLabel() }}</span>
        <i class="pdp-caret" aria-hidden="true"></i>
      </button>
      <ul class="pdp-drop-menu" *ngIf="openDrop === 'month'">
        <li *ngFor="let m of months">
          <button type="button" class="pdp-drop-item" [class.selected]="m.value === month"
            (click)="selectMonth(m.value)">{{ m.label }}</button>
        </li>
      </ul>
    </div>

    <div class="pdp-drop pdp-cal-year" [class.open]="openDrop === 'year'">
      <button type="button" class="pdp-drop-btn" (click)="toggleDrop('year', $event)"
        [attr.aria-expanded]="openDrop === 'year'">
        <span class="pdp-drop-value">{{ year }}</span>
        <i class="pdp-caret" aria-hidden="true"></i>
      </button>
      <ul class="pdp-drop-menu" *ngIf="openDrop === 'year'">
        <li *ngFor="let y of years">
          <button type="button" class="pdp-drop-item" [class.selected]="y === year"
            (click)="selectYear(y)">{{ y }}</button>
        </li>
      </ul>
    </div>

    <div class="pdp-drop pdp-kind-drop" [class.open]="openDrop === 'kind'">
      <button type="button" class="pdp-drop-btn" (click)="toggleDrop('kind', $event)"
        [attr.aria-expanded]="openDrop === 'kind'">
        <span class="pdp-drop-value">{{ kindLabel() | translate }}</span>
        <i class="pdp-caret" aria-hidden="true"></i>
      </button>
      <ul class="pdp-drop-menu" *ngIf="openDrop === 'kind'">
        <li *ngFor="let k of kinds">
          <button type="button" class="pdp-drop-item" [class.selected]="k.value === kind"
            (click)="selectKind(k.value)">{{ k.label | translate }}</button>
        </li>
      </ul>
    </div>

    <!-- Next month -->
    <button type="button" class="pdp-cal-nav" (click)="nextMonth()" [disabled]="!canNextMonth()"
      [attr.aria-label]="'HOME.calendar_next_month' | translate" [title]="'HOME.calendar_next_month' | translate">&rsaquo;</button>

    <button type="button" class="pdp-close" (click)="close()" [attr.aria-label]="'HOME.calendar_close' | translate"
      [title]="'HOME.calendar_close' | translate">&times;</button>
  </div>

  <div class="pdp-body">
    <div class="pdp-list-col">
      <ng-container *ngIf="loading">
        <div class="pdp-group">
          <h3 class="pdp-date shimmer"></h3>
          <div class="pdp-list">
            <div class="pdp-item skeleton" *ngFor="let n of [1,2,3,4]">
              <span class="pdp-thumb shimmer"></span>
              <span class="pdp-text"><span class="pdp-line shimmer"></span><span class="pdp-line short shimmer"></span></span>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="pdp-empty" *ngIf="!loading && error">
        <p>{{ 'HOME.calendar_error' | translate }}</p>
        <button type="button" class="pdp-retry" (click)="fetch()">{{ 'HOME.calendar_retry' | translate }}</button>
      </div>

      <div class="pdp-empty" *ngIf="!loading && !error && groups.length === 0">
        <p>{{ 'HOME.calendar_empty' | translate }}</p>
      </div>

      <div class="pdp-group" *ngFor="let group of groups; trackBy: trackGroup" [attr.id]="groupId(group.date)"
        [class.selected]="isSelectedDay(group.date)">
        <h3 class="pdp-date">{{ group.label }}</h3>
        <div class="pdp-list">
          <a href="javascript:void(0)" class="pdp-item" *ngFor="let item of group.items; trackBy: trackItem"
            (click)="open(item)" [attr.title]="item.title">
            <span class="pdp-thumb">
              <img [src]="thumb(item)" [alt]="item.title" loading="lazy" />
              <span class="pdp-duration" *ngIf="item.duration">{{ item.duration }}</span>
            </span>
            <span class="pdp-text">
              <span class="pdp-title">{{ item.title }}</span>
              <span class="pdp-desc" *ngIf="item.descText">{{ item.descText }}</span>
            </span>
            <span class="pdp-kind" [class.audio]="item.type === 'audio'">
              <svg *ngIf="item.type === 'audio'" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
                <path fill="currentColor" d="M12 3a9 9 0 0 0-9 9v7a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5v-1a7 7 0 0 1 14 0v1h-2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-7a9 9 0 0 0-9-9z"/>
              </svg>
              <svg *ngIf="item.type !== 'audio'" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
                <path fill="currentColor" d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-2-12v8l6-4z"/>
              </svg>
            </span>
            <span class="pdp-chevron" aria-hidden="true">&rsaquo;</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
